import React, { useEffect } from "react";
import { useAiColsConfig, useUserVip } from "@/stores/appStore";
import Loading from "@/components/Loading";
import { UpgradeVipButton } from "@/components/payment/UpgradeVipButton";

export type LimitType = 'custom' | 'aicols';

export type AIColLimitFloatingCardOptions = {
  limitType?: LimitType;
};

export function AIColLimitFloatingCard({
  limitType = 'custom'
}: AIColLimitFloatingCardOptions) {
  const {
    limits,
    vip,
  } = useUserVip();

  const {
    fetch,
    value: config,
  } = useAiColsConfig();

  useEffect(() => {
    fetch();
  }, [fetch]);

  if (!limits || !config) {
    return <></>;
  }

  return (
    <div
      className="flex flex-col border border-border rounded-md shadow-[0_4px_10px_0_rgba(0,0,0,0.1)] bg-background text-sm w-[310px] p-6"
    >
      {
        limits ? (
          <>
            <div className="font-medium">
              {
                limitType === 'custom' ?
                  '创建自定义 AI 表格列已达上限' :
                  '当前表格展示已达上限'
              }
            </div>
            <div className="text-muted-foreground mt-2">
              {
                limitType === 'custom' ?
                  (vip === 1 ? `Plus 会员最多可创建 ${config.customVipLimit} 个。 ` : `当前最多可创建 ${config.customLimit} 个，升级 Plus 会员可创建 ${config.customVipLimit} 个。`) :
                  `最多可同时展示 ${config.aiColsLimit} 列，升级 Plus 会员可全部展示。`
              }
            </div>
            {
              vip === 1 ? null : (
                <UpgradeVipButton className="justify-center w-[176px] self-center mt-4">
                  升级 Plus 会员
                </UpgradeVipButton>
              )
            }
          </>
        ) : (
          <Loading mask />
        )
      }
    </div>
  );
} 